import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const roleHome = (role) => {
  if (role === 'user') return '/attendee-dashboard';
  if (role === 'event_editor' || role === 'device_scanner') return '/my-events';
  if (role === 'vendor') return '/vendor/overview';
  return '/dashboard'; // super_admin, admin, event_admin
};

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="inline-block w-10 h-10 border-2 border-[#1672b9] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Send the user to their own home page instead of a dead-end
    return <Navigate to={roleHome(user.role)} replace />;
  }

  return children;
};

export default ProtectedRoute;